import moment from 'moment';
import axiosClient, { HOST } from './axiosClient';
import { scan } from '../components/familytree/scripts/aws-dynamo-user';

const userService = {
  getListUser: (params) => scan(params),
  getUserDetail: (id) => axiosClient.get(`${HOST.USER_SERVICE}/admin-users/${id}`),
  createUser: (data) => axiosClient.post(`${HOST.USER_SERVICE}/admin-users`, data),
  updateUser: (data) => axiosClient.put(`${HOST.USER_SERVICE}/admin-users`, data),
  getListWorkplace: (params) =>
    axiosClient.get(`${HOST.PRODUCT_SERVICE}/product/banks`, { params }),
  getListUserRole: (params) =>
    axiosClient.get(`${HOST.USER_SERVICE}/admin-users/roles`, { params }),
  getListProductType: (code) => axiosClient.get(`${HOST.PRODUCT_SERVICE}/product/bank/${code}`),
  getOTP: (email) =>
    axiosClient
      .put(`${HOST.USER_SERVICE}/admin-users/genotp?email=${email}`)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error)),
  changePassword: (data) =>
    axiosClient
      .put(`${HOST.USER_SERVICE}/admin-users/change-password`, data)
      .then((response) => Promise.resolve(response))
      .catch((error) => Promise.reject(error)),
  exportData: (params) =>
    axiosClient
      .get(`${HOST.USER_SERVICE}/admin-users/export`, {
        params,
        responseType: 'blob',
      })
      .then((res) => {
        const currentDate = moment(new Date()).format('DDMMYYYY');
        const urll = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = urll;
        link.setAttribute('download', `User_${currentDate}.xlsx`); // or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .catch((error) => {
        if (error.response) {
          return Promise.reject(error.response);
        }
        return Promise.reject(error);
      }),
};

export default userService;
